dispContacts = [
  { 'text': 'Sud-Ouest (Bordeaux)', 'value': 'bordeaux@oip.org' },
  { 'text': 'Grand-Centre (Dijon)', 'value': 'coordination.centre-est@oip.org' },
  { 'text': 'Grand-Est (Strasbourg)', 'value': 'coordination.centre-est@oip.org' },
  { 'text': 'Grand-Nord (Lille)', 'value': 'nord-ouest@oip.org' },
  { 'text': 'Centre-Est (Lyon)', 'value': 'charline.becker@oip.org,lyon@oip.org,sud-est@oip.org' },
  { 'text': 'Sud-Est (Marseille)', 'value': 'charline.becker@oip.org,lyon@oip.org,sud-est@oip.org' },
  { 'text': 'Île-de-France (Paris)', 'value': 'ile-de-France@oip.org' },
  { 'text': 'Grand-Ouest (Rennes)', 'value': 'nord-ouest@oip.org' },
  { 'text': 'Sud (Toulouse)', 'value': 'toulouse@oip.org' },
  { 'text': 'Mission Outremer', 'value': 'outre-mer@oip.org' }
]

let dispSelect = document.getElementById('disp-select');

if (dispSelect) {
  // disable the select option placeholder
  dispSelect.options[0].setAttribute('disabled', true)
  dispSelect.options[0].value = ''

  // add all etablissements to select options
  for (let i = 0; i < dispContacts.length; i ++) {
    dispSelect.options[dispSelect.options.length] = new Option(dispContacts[i].text, dispContacts[i].value);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/temoigner.js